<label [ngClass]="[sizeClass, colorClass]">
	<span *ngIf="text$">{{ text$ | async }}</span> <ng-content></ng-content
></label>
